import Vue from 'vue';
import Router from 'vue-router';
// 混入工具方法
import mixinTools from '@/assets/js/mixinTools.js';
// i18n-titleZhCHS
import titleZhCHS from '@/assets/json/i18n/titleZhCHS.json';
// i18n-titleZhCHT
import titleZhCHT from '@/assets/json/i18n/titleZhCHT.json';
// i18n-titleEn
import titleEn from '@/assets/json/i18n/titleEn.json';

Vue.use(Router);

// 获取当前语言
const i18nLocale = mixinTools.methods.$getCookie('i18n') || 'zhCHS';

// 当前语言数据对象
const nowLocaleObj = {
    zhCHS: titleZhCHS,
    zhCHT: titleZhCHT,
    en: titleEn,
};

// 切换title
function $t(title) {
    return nowLocaleObj[i18nLocale][title];
}

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Index',
            meta: {title: $t('index')},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            component: () => import('./views/Index.vue')
        },
        {
            path: '/ImportHome',
            name: 'ImportHome',
            meta: {title: 'importHome'},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            component: () => import('./views/ImportHome.vue')
        },
        {
            path: '/product/airlinesDirectOrdering',
            name: 'AirlineDirect',
            meta: {title: '航司直订'},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            component: () => import('./views/product/AirlinesDirectOrdering.vue')
        },
        {
            path: '/product/airlinesDirectOrderingChangeDate',
            name: 'AirlineDirectChangeDate',
            meta: {title: '航司直订改期'},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            component: () => import('./views/product/AirlinesDirectOrderingChangeDate.vue')
        },
        {
            path: '/product/event',
            name: 'Event',
            meta: {title: '活动'},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            component: () => import('./views/product/Event.vue')
        },
        {
            path: '/product/eventList',
            name: 'EventList',
            meta: {title: '活动'},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            component: () => import('./views/product/EventList.vue')
        },     
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/ImportLogin',
            name: 'ImportLogin',
            meta: {title: $t('signIn')},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/ImportLogin.vue')
        },
        {
            path: '/UserAgreement',
            name: 'UserAgreement',
            meta: {title: '三脚猫平台服务协议'},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            component: () => import('./views/UserAgreement.vue')
        },
        {
            path: '/UserAgreementEn',
            name: 'UserAgreementEn',
            meta: {title: 'Service Agreement of the 3-J Mall Platform'},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            component: () => import('./views/UserAgreementEn.vue')
        },
        {
            path: '/PrivacyPolicy',
            name: 'PrivacyPolicy',
            meta: {title: '隐私政策'},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            component: () => import('./views/PrivacyPolicy.vue')
        },
        {
            path: '/PrivacyPolicyEn',
            name: 'PrivacyPolicyEn',
            meta: {title: 'PrivacyPolicy'},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            component: () => import('./views/PrivacyPolicyEn.vue')
        },
        {
            path: '/index.html',
            meta: {title: $t('index')},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            redirect: '/'
        },
        {
            path: '/Default.aspx',
            meta: {title: $t('index')},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            redirect: '/'
        },
        {
            path: '/Register',
            name: 'Register',
            meta: {title: $t('register') + '-' + $t('3jmall')},// 用户注册-三脚猫电商
            component: () => import('./views/Register.vue')
        },
        {
            path: '/RetrievePassword',
            name: 'RetrievePassword',
            meta: {title: $t('retrievePWD') + '-' + $t('3jmall')},// 找回密码-三脚猫电商
            component: () => import('./views/RetrievePassword.vue')
        },
        {
            path: '/supplier/StoreSearch',
            name: 'StoreSearch',
            meta: {title: $t('storeSearch') + '-' + $t('3jmall')},// 店铺搜索-三脚猫电商
            component: () => import('./views/supplier/StoreSearch.vue')
        },
        {
            path: '/supplier/SupplierStoreMain',
            name: 'SupplierStoreMain',
            meta: {title: '供应商店铺' + '-' + $t('3jmall')},// 供应商店铺-三脚猫电商
            component: () => import('./views/supplier/SupplierStoreMain.vue')
        },
        {
            path: '/tools/DeliveryInformation',
            name: 'DeliveryInformation',
            meta: {title: $t('deliveryInfo') + '-' + $t('3jmall')},// 交货资料-三脚猫电商
            component: () => import('./views/tools/DeliveryInformation.vue')
        },
        {
            path: '/tools/ImportDatabase',
            name: 'ImportDatabase',
            meta: {title: $t('importDatabase') + '-' + $t('3jmall')},// 进口资料库-三脚猫电商
            component: () => import('./views/tools/ImportDatabase.vue')
        },
        {
            path: '/tools/MiscellaneousBillsList',
            name: 'MiscellaneousBillsList',
            meta: {title: $t('miscellaneousBillsList') + '-' + $t('3jmall')},// 杂费清单-三脚猫电商
            component: () => import('./views/tools/MiscellaneousBillsList.vue')
        },
        {
            path: '/tools/AppDownload',
            name: 'AppDownload',
            meta: {title: $t('3jmallApp') + '-' + $t('3jmall')},// 三脚猫电商App下载-三脚猫电商
            component: () => import('./views/tools/AppDownload.vue')
        },
        {
            path: '/tools/BecomeMember',
            name: 'BecomeMember',
            meta: {title: '成为会员' + '-' + $t('3jmall')},// 成为会员-三脚猫电商
            component: () => import('./views/tools/BecomeMember.vue')
        },
        {
            path: '/tools/MemberCostStandard',
            name: 'MemberCostStandard',
            meta: {title: '会员费用清单' + '-' + $t('3jmall')},// 成为会员费用清单-三脚猫电商
            component: () => import('./views/tools/MemberCostStandard.vue')
        },
        {
            path: '/tools/SelfInquireDay',
            name: 'SelfInquireDay',
            meta: {title: $t('selfInquireDay') + '-' + $t('3jmall')},// 自查日-三脚猫电商
            component: () => import('./views/tools/SelfInquireDay.vue')
        },
        {
            path: '/product/ProductCart',
            name: 'ProductCart',
            meta: {title: $t('cart') + '-' + $t('3jmall')},// 购物车-三脚猫电商
            component: () => import('./views/product/ProductCart.vue')
        },
        {
            path: '/product/ProductsComment',
            name: 'ProductsComment',
            meta: {title: $t('productsComment') + '-' + $t('3jmall')},// 产品评论-三脚猫电商
            component: () => import('./views/product/ProductsComment.vue')
        },
        {
            path: '/product/HistoryQuote',
            name: 'HistoryQuote',
            meta: {title: $t('historyQuote') + '-' + $t('3jmall')},// 历史报价-三脚猫电商
            component: () => import('./views/product/HistoryQuote.vue')
        },
        {
            path: '/product/SmartSearch',
            name: 'SmartSearch',
            meta: {title: $t('smartSearch') + '-' + $t('3jmall')},// 智能检索页-三脚猫电商
            component: () => import('./views/product/SmartSearch.vue')
        },
        {
            path: '/product/SmartProducts',
            name: 'SmartProducts',
            meta: {title: $t('smartProducts') + '-' + $t('3jmall')}, // 智能订舱-三脚猫电商
            component: () => import('./views/product/SmartProducts.vue')
        },
        {
            path: '/product/Singles2019',
            name: 'Singles2019',
            meta: {title: $t('tray') + '-' + $t('3jmall')},// 托书页-三脚猫电商
            component: () => import('./views/product/Singles2019.vue')
        },
        {
            path: '/product/ResumptionTime',
            name: 'ResumptionTime',
            meta: {title: '复飞时间一览表' + '-' + $t('3jmall')},// 复飞时间一览表-三脚猫电商
            component: () => import('./views/product/ResumptionTime.vue')
        },
        {
            path: '/jianghu/Guide',
            name: 'Guide',
            meta: {title: $t('jianghu') + '-' + $t('3jmall')},// 江湖-三脚猫电商
            component: () => import('./views/jianghu/Guide.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/ActivationCodeLogin',
            name: 'ActivationCodeLogin',
            meta: {title: $t('inputActivationCode') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口输入激活码-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/ActivationCodeLogin.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/ImportFeeCount',
            name: 'ImportFeeCount',
            meta: {title: $t('feeSimulator') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口费用模拟器-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/ImportFeeCount.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/ActivateUserBills',
            name: 'ActivateUserBills',
            meta: {title: $t('activationCodeBillView') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口激活码用户账单查看-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/ActivateUserBills.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/ActivationCodeUserIndex',
            name: 'ActivationCodeUserIndex',
            meta: {title: $t('activationCodeIndex') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口激活码用户主页-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/ActivationCodeUserIndex.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain',
            name: 'ImportBusinessMain',
            meta: {title: $t('importBusinessIndex') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口管理主页-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/BatchPicking',
            name: 'BatchPicking',
            meta: {title: $t('batchPicking') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 批量提货-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/BatchPicking.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/Distribution',
            name: 'Distribute',
            meta: {title: $t('distribute') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 批量提货-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/Distribute.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/DistributeOrder',
            name: 'DistributeOrder',
            meta: {title: $t('distributeOrder') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 批量提货-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/DistributeOrder.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/EnterActivationCode',
            name: 'EnterActivationCode',
            meta: {title: $t('enterActivationCode') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 批量提货-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/EnterActivationCode.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/OrderTransfer',
            name: 'OrderTransfer',
            meta: {title: $t('orderTransfer') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 批量提货-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/OrderTransfer.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/DistributeActivationCode',
            name: 'DistributeActivationCode',
            meta: {title: $t('distributeActivationCode') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 批量提货-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/DistributeActivationCode.vue')
        },
        // {
        //     path: '/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain_linshi',
        //     name: 'ImportBusinessMain_linshi',
        //     meta: {title: $t('importBusinessIndex') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口管理主页-个人中心-三脚猫电商_临时
        //     component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/ImportBusinessMain_linshi.vue')
        // },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/LoginUserBills',
            name: 'LoginUserBills',
            meta: {title: $t('loginUserBillView') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口注册用户账单查看-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/LoginUserBills.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/Forecast',
            name: 'Forecast',
            meta: {title: $t('forecast') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口发布预报-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/Forecast.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/FinancialCenter',
            name: 'FinancialCenter',
            meta: {title: $t('forecast') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口财务中心-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/FinancialCenter.vue'),
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/WriteOffRecord',
            name: 'WriteOffRecord',
            meta: {title: $t('Viewwriteoffrecords') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口核销记录-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/WriteOffRecord.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/importPaymentDistribution',
            name: 'WriteOffRecord',
            meta: {title: $t('Paymentdistribution') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口打款分配-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/importPaymentDistribution.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/PaymentRecord',
            name: 'PaymentRecord',
            meta: {title: $t('Viewhistoricalpaymentrecords') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口查看历史打款记录-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/PaymentRecord.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/PickUpCargoBatch',
            name: 'PickUpCargoBatch',
            meta: {title: $t('Importdelivery') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口批量提货-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/PickUpCargoBatch.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/PointExchange',
            name: 'PointExchange',
            meta: {title: $t('pointsExchange') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口批量提货-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/PointExchange.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/PickUpCargo',
            name: 'PickUpCargo',
            meta: {title: $t('Importdelivery') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口提货-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/PickUpCargo.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/ActivationPickUpCargo',
            name: 'ActivationPickUpCargo',
            meta: {title: $t('Pickupwithimportactivationcode') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口激活码提货-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/ActivationPickUpCargo.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/SettleAccounts',
            name: 'SettleAccounts',
            meta: {title: $t('Importsettlement') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口结算-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/SettleAccounts.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/BatchSettleAccounts',
            name: 'BatchSettleAccounts',
            meta: {title: $t('Importsettlement') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口结算-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/BatchSettleAccounts.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/OtherPayUrl',
            name: 'OtherPayUrl',
            meta: {title: $t('Importpayment') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口代付-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/OtherPayUrl.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/OtherPayUrlBatch',
            name: 'OtherPayUrl',
            meta: {title: $t('Importpayment') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口批量找人代付-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/OtherPayUrlBatch.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/CloudPan',
            name: 'ImportCloudPan',
            meta: {title: $t('Stockcheckingofimportshipmentbycloudsystem') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口云盘-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/CloudPan.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/CustomService',
            name: 'ImportCustomService',
            meta: {title: $t('Importcustombuiltservice') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进口定制服务-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/CustomService.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/TemplateChoose',
            name: 'TemplateChoose',
            meta: {title: $t('Templateselection') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 模板选择-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/TemplateChoose.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/TemplateList',
            name: 'TemplateList',
            meta: {title: $t('Templatelist') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 模板列表-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/TemplateList.vue')
        },
        // {
        //     path: '/personalCenter/operationCenter/cargoQuery/importBusiness/TemplateCreateBackup',
        //     name: 'TemplateCreate', 
        //     meta: {title: '模板创建' + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 模板创建-个人中心-三脚猫电商
        //     component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/TemplateCreateBackup.vue')
        // },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/TemplateCreate',
            name: 'TemplateCreate', 
            meta: {title: $t('Templatecreation') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 模板创建-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/TemplateCreate.vue')
        },
        {
            path: '/personalCenter/cargoDelayInsurance/CertificateOfInsurance',
            name: 'CertificateOfInsurance',
            meta: {title: $t('cargoExtendedInsurance')},// 货延险赔付单
            component: () => import('./views/personalCenter/cargoDelayInsurance/CertificateOfInsurance.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/exportBusiness/EntryMap',
            name: 'EntryMap',
            meta: {title: $t('warehouseMap') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进仓地图-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/EntryMap.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/EntryMap',
            name: 'EntryMap',
            meta: {title: $t('warehouseMap') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 进仓地图-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/EntryMap.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/exportBusiness/EntryMapMobile',
            name: 'EntryMapMobile',
            meta: {title: $t('mobileWarehouseMap') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 移动端进仓地图-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/EntryMapMobile.vue')
        },
        {
            path: '/personalCenter/financeCenter/financeManagement/FinanceManagementDetail',
            name: 'FinanceManagementDetail',
            meta: {title: $t('financialDetails') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 财务明细-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/financeCenter/financeManagement/FinanceManagementDetail.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/exportBusiness/OrderInfo',
            name: 'OrderInfo',
            meta: {title: $t('trustingDetails') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 托书详情-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/OrderInfo.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/exportBusiness/ShutOutDoc',
            name: 'ShutOutDoc',
            meta: {title: $t('DescriptionofCustomCargoShutout') + '-' + $t('exportBusiness') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 退关情况说明-出口业务-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/ShutOutDoc.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/exportBusiness/ReturnCargoDoc',
            name: 'ReturnCargoDoc',
            meta: {title: $t('Deliveryvoucher') + '-' + $t('exportBusiness') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 放货凭证-出口业务-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/ReturnCargoDoc.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/exportBusiness/CustomService',
            name: 'CustomService',
            meta: {title: $t('Custombuiltservice') + '-' + $t('exportBusiness') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 定制服务-出口业务-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/CustomService.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/exportBusiness/BookingLog',
            name: 'BookingLog',
            meta: {title: $t('bookingLog') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 订舱日志-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/BookingLog.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/ImportOperateLog',
            name: 'ImportOperateLog',
            meta: {title: '进口操作日志'},// 三脚猫电商-国际物流空运网上订舱平台_国际货代航空运输|价格查询
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/ImportOperateLog.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/exportBusiness/writeOffHistory',
            name: 'writeOffHistory',
            meta: {title: $t('Viewwriteoffrecords') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 出口核销记录-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/writeOffHistory.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/exportBusiness/paymentDistribution',
            name: 'writeOffHistory',
            meta: {title: $t('Paymentdistribution') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 出口打款分配-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/paymentDistribution.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/exportBusiness/paymentRecord',
            name: 'writeOffHistory',
            meta: {title: $t('Viewhistoricalpaymentrecords') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 出口历史打款记录-个人中心-三脚猫电商
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/paymentRecord.vue')
        },
        {
            path: '/personalCenter/PersonalCenterMain',
            meta: {title: $t('personalCenter') + '-' + $t('3jmall')},// 个人中心-三脚猫电商
            component: () => import('./views/personalCenter/PersonalCenterMain.vue'),
            children: [
                {
                    path: 'AllocationBoard',
                    name: 'Cabin',
                    mata: {title: '包板'},
                    component: () => import('./views/product/AllocationBoard.vue')
                },
                {
                    path: 'AllocationBoard1',
                    name: 'Cabin1',
                    mata: {title: '包板'},
                    component: () => import('./views/product/AllocationBoard1.vue')
                },
                {
                    path: 'DebitsOrder',
                    name: 'DebitsOrder',
                    meta: {title: '借单'},
                    component: () => import('./views/product/DebitsOrder.vue')
                },
                {
                    path: 'accountCenter/accountManagement/AccountManagement',
                    name: 'AccountManagement',
                    meta: {title: $t('accountManagement') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 账户管理-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/accountManagement/AccountManagement.vue')
                },
                {
                    path: 'accountCenter/accountManagement/CreatAccount',
                    name: 'CreatAccount',
                    meta: {title: $t('accountManagement') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 账户管理-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/accountManagement/CreatAccount.vue')
                },
                {
                    path: 'accountCenter/accountManagement/AccountManagementForPersonalBuyer',
                    name: 'AccountManagementForPersonalBuyer',
                    meta: {title: $t('accountManagement') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 个人买家账户管理-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/accountManagement/AccountManagementForPersonalBuyer.vue')
                },
                {
                    path: 'accountCenter/accountManagement/FunctionDistribution',
                    name: 'FunctionDistribution',
                    meta: {title: $t('functionalAllocation') + '-' + $t('accountManagement') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 功能分配-账户管理-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/accountManagement/FunctionDistribution.vue')
                },
                {
                    path: 'accountCenter/accountManagement/SubAccountAddOrReset',
                    name: 'SubAccountAddOrReset',
                    meta: {title: $t('sub-accountManagement') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 分账户管理-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/accountManagement/SubAccountAddOrReset.vue')
                },
                {
                    path: 'accountCenter/agreementCertification/CertInit',
                    name: 'CertInit',
                    meta: {title: $t('additionalProtocolCertification') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 新增协议认证-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/agreementCertification/CertInit.vue')
                },
                {
                    path: 'accountCenter/agreementCertification/CertMain',
                    name: 'CertMain',
                    meta: {title: $t('protocolAuthentication') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 协议认证-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/agreementCertification/CertMain.vue')
                },
                {
                    path: 'accountCenter/agreementCertification/CertWrite',
                    name: 'CertWrite',
                    meta: {title: $t('protocolAuthenticationInfoInput') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 协议认证信息输入-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/agreementCertification/CertWrite.vue')
                },
                {
                    path: 'accountCenter/agreementCertificationEn/AgreementMainEn',
                    name: 'AgreementMainEn',
                    meta: {title: $t('protocolAuthentication') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 协议认证主页海外版-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/agreementCertificationEn/AgreementMainEn.vue')
                },
                {
                    path: 'accountCenter/agreementCertificationEn/AgreementChooseEn',
                    name: 'AgreementChooseEn',
                    meta: {title: $t('additionalProtocolCertification') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 协议认证选择海外版-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/agreementCertificationEn/AgreementChooseEn.vue')
                },
                {
                    path: 'accountCenter/agreementCertificationEn/AgreementSubmitEn',
                    name: 'AgreementSubmitEn',
                    meta: {title: $t('protocolAuthenticationInfoInput') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 协议认证信息输入海外版-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/agreementCertificationEn/AgreementSubmitEn.vue')
                },
                {
                    path: 'accountCenter/commentManagement/CommentManagement',
                    name: 'CommentManagement',
                    meta: {title: $t('commentManagement') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 评论管理-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/commentManagement/CommentManagement.vue')
                },
                {
                    path: 'accountCenter/creditManagement/PointManagement',
                    name: 'PointManagement',
                    meta: {title: $t('pointsManagement') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 积分管理-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/creditManagement/PointManagement.vue')
                },
                {
                    path: 'accountCenter/creditManagement/PointsExchange',
                    name: 'PointsExchange',
                    meta: {title: $t('pointsExchange') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 积分兑换-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/creditManagement/PointsExchange.vue')
                },
                {
                    path: 'accountCenter/securityCenter/ModifyPassword',
                    name: 'ModifyPassword',
                    meta: {title: $t('securityCenter') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 安全中心-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/accountCenter/securityCenter/ModifyPassword.vue')
                },
                {
                    path: 'financeCenter/financeManagement/FinanceManagementMain_backup',
                    name: 'FinanceManagementMain',
                    meta: {title: $t('financialManagement') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 财务管理-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/financeCenter/financeManagement/FinanceManagementMain_backup.vue')
                },
                {
                    path: 'financeCenter/financeManagement/FinanceManagementMain',
                    name: 'FinanceManagementMain',
                    meta: {title: $t('financialManagement') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 财务管理-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/financeCenter/financeManagement/FinanceManagementMain.vue')
                },
                {
                    path: 'financeCenter/financeManagement/FinanceManagementMainExport',
                    name: 'FinanceManagementMainExport',
                    meta: {title: $t('financialManagement') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 财务管理-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/financeCenter/financeManagement/FinanceManagementMainExport.vue')
                },
                // {
                //     path: 'financeCenter/financeManagement/FinanceBillWriteOff',
                //     name: 'FinanceBillWriteOff',
                //     meta: {title: $t('billWriteOff') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 账单核销-个人中心-三脚猫电商
                //     component: () => import('./views/personalCenter/financeCenter/financeManagement/FinanceBillWriteOff.vue')
                // },
                {
                    path: 'operationCenter/cargoQuery/exportBusiness/ChangeDate',
                    name: 'ChangeDate',
                    meta: {title: $t('rescheduledPage') + '-' + $t('exportBusiness') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 改期页-出口业务-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/ChangeDate.vue')
                },
                {
                    path: 'operationCenter/cargoQuery/exportBusiness/CostConfirm',
                    name: 'CostConfirm',
                    meta: {title: $t('costConfirmation') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 费用确认-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/CostConfirm.vue')
                },
                {
                    path: 'operationCenter/cargoQuery/exportBusiness/DataToConfirm',
                    name: 'DataToConfirm',
                    meta: {title: $t('dataConfirm') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 数据确认页-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/DataToConfirm.vue')
                },
                {
                    path: 'operationCenter/cargoQuery/exportBusiness/ExportBusinessMain',
                    name: 'ExportBusinessMain',
                    meta: {title: $t('exportBusiness') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 出口业务-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/ExportBusinessMain.vue')
                },
                // {
                //     path: 'operationCenter/cargoQuery/exportBusiness/ExportBusinessMain_backup',
                //     name: 'ExportBusinessMain222',
                //     meta: {title: '出口backup'},// 出口业务-个人中心-三脚猫电商
                //     component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/ExportBusinessMain_backup.vue')
                // },
                {
                    path: 'operationCenter/cargoQuery/exportBusiness/ExportBusinessMainEn',
                    name: 'ExportBusinessMainEn',
                    meta: {title: $t('exportBusiness') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 出口业务海外版-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/ExportBusinessMainEn.vue')
                },
                {
                    path: 'operationCenter/cargoQuery/exportBusiness/CloudPan',
                    name: 'CloudPan',
                    meta: {title: '云盘' + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 云盘-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/CloudPan.vue')
                },
                {
                    path: 'operationCenter/cargoQuery/exportBusiness/makeBill/AirWaybillTemplate',
                    name: 'AirWaybillTemplate',
                    meta: {title: $t('airWaybillTemplate') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 制单模板-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/makeBill/AirWaybillTemplate.vue')
                },
                {
                    path: 'operationCenter/cargoQuery/exportBusiness/makeBill/AirWaybillTemplate2',
                    name: 'AirWaybillTemplate2',
                    meta: {title: $t('airWaybillTemplate') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 制单模板-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/makeBill/AirWaybillTemplate2.vue')
                },
                {
                    path: 'operationCenter/cargoQuery/exportBusiness/makeBill/AirWaybillMain_backup',
                    name: 'AirWaybillMain_backup',
                    meta: {title: $t('airWaybillMain') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 制单主页-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/makeBill/AirWaybillMain_backup.vue')
                },
                {
                    path: 'operationCenter/cargoQuery/exportBusiness/makeBill/AirWaybillMain',
                    name: 'AirWaybillMain',
                    meta: {title: $t('airWaybillMain') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 制单主页-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/makeBill/AirWaybillMain.vue')
                },
                {
                    path: 'operationCenter/cargoQuery/exportBusiness/makeBill/MakeMasterAirWaybill_backup',
                    name: 'MakeMasterAirWaybill_backup',
                    meta: {title: $t('makeMasterAirWaybill') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 主单制作-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/makeBill/MakeMasterAirWaybill_backup.vue')
                },
                {
                    path: 'operationCenter/cargoQuery/exportBusiness/makeBill/MakeMasterAirWaybill',
                    name: 'MakeMasterAirWaybill',
                    meta: {title: $t('makeMasterAirWaybill') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 主单制作-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/makeBill/MakeMasterAirWaybill.vue')
                },
                {
                    path: 'operationCenter/cargoQuery/exportBusiness/makeBill/MakeHouseAirWaybill',
                    name: 'MakeHouseAirWaybill',
                    meta: {title: $t('makeHouseAirWaybill') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 分单制作-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/cargoQuery/exportBusiness/makeBill/MakeHouseAirWaybill.vue')
                },
                {
                    path: 'operationCenter/couponManagement/CouponManagement',
                    name: 'CouponManagement',
                    meta: {title: $t('couponManagement') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 优惠券管理-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/operationCenter/couponManagement/CouponManagement.vue')
                },
                {
                    path: 'personalInfo/AccountInfoModify',
                    name: 'AccountInfoModify1',
                    meta: {title: $t('accountInfoChange') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 账户资料修改-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/personalInfo/AccountInfoModify1.vue')
                },
                {
                    path: 'personalInfo/AccountInfoModifyEn',
                    name: 'AccountInfoModifyEn',
                    meta: {title: $t('accountInfoChange') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 账户资料修改-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/personalInfo/AccountInfoModifyEn.vue')
                },
                {
                    path: 'IncomePoints',
                    name: 'IncomePoints',
                    meta: {title: $t('incomePoints') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 收益积分-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/IncomePoints.vue')
                },
                {
                    path: 'insurance/CargoValueInsuranceMain',
                    name: 'CargoValueInsuranceMain',
                    meta: {title: $t('cargoValueInsurance') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 货值险-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/insurance/CargoValueInsuranceMain.vue')
                },
                {
                    path: 'insurance/CargoDelayInsuranceMain',
                    name: 'CargoDelayInsuranceMain',
                    meta: {title: $t('cargoDelayInsurance') + '-' + $t('personalCenter') + '-' + $t('3jmall')},// 货延险-个人中心-三脚猫电商
                    component: () => import('./views/personalCenter/insurance/CargoDelayInsuranceMain.vue')
                },
            ]
        },
        // {
        //     path: '/cargoValueInsurance/BuyInsurance',
        //     name: 'BuyInsurance',
        //     meta: {title: $t('buyCargoValueInsurance') + '-' + $t('3jmall')},// 购买货值险-三脚猫电商
        //     component: () => import('./views/cargoValueInsurance/BuyInsurance.vue')
        // },
        {
            path: '/cargoValueInsurance/ViewInsurance',
            name: 'ViewInsurance',
            meta: {title: $t('viewCargoValueInsurance') + '-' + $t('3jmall')},// 查看货值险-三脚猫电商
            component: () => import('./views/cargoValueInsurance/ViewInsurance.vue')
        },
        // {
        //     path: '/cargoValueInsurance/InsurancePromote',
        //     name: 'InsurancePromote',
        //     meta: {title: $t('cargoValueInsurancePromote') + '-' + $t('3jmall')},// 货值险推广-三脚猫电商
        //     component: () => import('./views/cargoValueInsurance/InsurancePromote.vue')
        // },
        {
            path: '/activity/doubleEleven2019/Vote',
            name: 'Vote',
            meta: {title: '双11产品投票-' + $t('3jmall')},// 双11产品投票-三脚猫电商
            component: () => import('./views/activity/doubleEleven2019/Vote.vue')
        },
        {
            path: '/activity/doubleEleven2019/Product',
            name: 'Product',
            meta: {title: '双11 你说了算-' + $t('3jmall')},// 双11 你说了算-三脚猫电商
            component: () => import('./views/activity/doubleEleven2019/Product.vue')
        },
        {
            path: '/domesticFactory/DomesticFactoryMain',
            name: 'DomesticFactoryMain',
            meta: {title: '国内工厂主页-' + $t('3jmall')},// 国内工厂主页-三脚猫电商
            component: () => import('./views/domesticFactory/DomesticFactoryMain.vue')
        },
        {
            path: '/activity/DoubleTwelve2019',
            name: 'DoubleTwelve2019',
            meta: {title: '12.12 狂欢延续-' + $t('3jmall')},// 12.12 狂欢延续-三脚猫电商
            component: () => import('./views/activity/DoubleTwelve2019.vue')
        },
        {
            path: '/activity/NewYearFestival2019',
            name: 'NewYearFestival2019',
            meta: {title: '2019年货节-' + $t('3jmall')},// 2019年货节-三脚猫电商
            component: () => import('./views/activity/NewYearFestival2019.vue')
        },
        {
            path: '/activity/Anniversary2020',
            name: 'Anniversary2020',
            meta: {title: '注册就能赚钱-' + $t('3jmall')},// 2020周年庆-三脚猫电商
            component: () => import('./views/activity/Anniversary2020.vue')
        },
        {
            path: '/activity/Anniversary2021',
            name: 'Anniversary2021',
            meta: {title: '周年庆任性宠你!-' + $t('3jmall')},// 2021周年庆-三脚猫电商
            component: () => import('./views/activity/Anniversary2021.vue')
        },
        {
            path: '/info/BookingInfo',
            name: 'BookingInfo',
            meta: {title: '订单信息-' + $t('3jmall')},// 订单信息-三脚猫电商
            component: () => import('./views/info/BookingInfo.vue')
        },
        {
            path: '/personalCenter/operationCenter/importPickupCargo/pickUpCargo',
            name: 'pickUpCargo',
            meta: {title: '三脚猫电商 | 提货单'},// iPad提货单页面
            component: () => import('./views/personalCenter/operationCenter/importPickupCargo/pickUpCargo.vue')
        },
        {
            path: '/personalCenter/operationCenter/importPickupCargo/Search',
            name: 'Search',
            meta: {title: '三脚猫电商 | 输入主题单号'},// iPad提货单输入页面
            component: () => import('./views/personalCenter/operationCenter/importPickupCargo/Search.vue')
        },
        {
            path: '/personalCenter/operationCenter/cargoQuery/importBusiness/ImportStation',
            name: 'ImportOversea',
            meta: {title: '三脚猫电商 | IMPORTSTATION'},
            component: () => import('./views/personalCenter/operationCenter/cargoQuery/importBusiness/ImportStation.vue')
        },
        // {
        //     path: '/importFreight/PriceQuery',
        //     name: 'ImportQuery',
        //     meta: {title: '进口查询' + '-' + $t('3jmall')}, // 智能订舱-三脚猫电商
        //     component: () => import('./views/importFreight/PriceQuery.vue')
        // },
        // {
        //     path: '/importFreight/ImportBooking',
        //     name: 'ImportBooking',
        //     meta: {title: '进口下单' + '-' + $t('3jmall')}, // 智能订舱-三脚猫电商
        //     component: () => import('./views/importFreight/ImportBooking.vue')
        // },
        {
            path: '/product/askPrice',
            name: 'AskPrice',
            meta: {title: '人工询价' + '-' + $t('3jmall')},
            component: () => import('./views/product/AskPrice.vue')
        },
        {
            path: '/TestDemo',
            name: 'TestDemo',
            meta: {title: 'TestDemo'},
            component: () => import('./views/TestDemo.vue')
        },
        {
            path: '*',
            name: 'Error',
            meta: {title: '404-' + $t('3jmall')},
            component: () => import('./views/Error.vue')
        }
    ]
});
